import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';

import { PlaceOption } from './placeopt';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceOptionType } from '../types';

const _schema = {
    "name": "DEVICEOPT",
    "fields": [
        { name: "option", type: "objid" },
        { name: "device", type: "string" },
        { name: "value", type: "string" },
    ],
    relate: [
        { direction: ">", target: "PLACEOPT", by: "devices", name: "option", reason: "option", child: false, class: PlaceOptionType },
    ]
} as const;

const _DeviceOptionClass = CreateObject(_schema);
if (!_DeviceOptionClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class DeviceOption extends _DeviceOptionClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): DeviceOption {
        return this._Copy(store) as DeviceOption;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'devices' && related instanceof PlaceOption){
            if (related === this.option){
                related.AddDevice(this);
            }
        }
    }

    get value(): string | null {
        return this['__base__value'];
    }

    set value(value: string | null) {
        this['__base__value'] = value;
    }

    /**
     * Sync-driven updates: apply runtime side-effects for logger campaign (`optionLoggerCampaign`).
     */
    protected override _OnUpdate(info: any): void {
        super._OnUpdate(info);
        setTimeout(() => this._ApplyOption(), 0);
    }

    private _ApplyOption(): void {
        if (!this.data.place || !this.device || this.device != this.data.device){
            return;
        }

        const _opkey = (this.option as PlaceOption | null)?.opkey;
        if (_opkey == 'optionLoggerCampaign'){
            this.data.place.Campaign(this.device);
        }
    }
}
